import assetUtils, { Asset } from 'app-lib/assetUtils'
import { chainConfigs, ChainId, getBlockExplorerAddressLink } from 'bzx-common/src/config/appConfig'
import { RootStore } from 'bzx-common/src/stores'
import * as mobx from 'mobx'
import { DialogVM } from 'ui-framework'

const ookiChains: ChainId[] = [1, 56, 137, 42161]

export default class DashboardVM {
  rootStore: RootStore
  appUpdatesViewMore = new DialogVM({ id: 'appUpdatesViewMore' })

  get ookiInfo() {
    return ookiChains.map((chainId) => {
      const info = assetUtils.getInfo(chainId, Asset.OOKI)
      return {
        ...info,
        chainIcon: chainConfigs[chainId].icon,
        chainId,
        ookiExplorerLink: getBlockExplorerAddressLink(chainId, info.address),
      }
    })
  }

  private init() {
    setTimeout(() => {
      !this.rootStore.statsStore.stats.loaded && this.rootStore.statsStore.stats.fetch()
      this.rootStore.stakingStore.dao.getSnapshotProposals()
      this.rootStore.blogStore.posts.fetch()
    }, 2000)
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { deep: false, autoBind: true })
    this.init()
  }
}
